export const getYoutubeVideoId = (url: string) => {
  if (url.includes('youtu.be')) {
    let splittedUrl = url.split('/');
    return splittedUrl[splittedUrl.length - 1];
  }
  let videoId = url.split('v=')[1];
  return videoId;
};
